let forms = {
	refer_product: {
		icon: 'fa fa-user',
		title: 'Refer Product',
		subtitle: 'Send product referal to friends',
		forms: [
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'email',
				validation: 'required|min:3|max:150|email',
				label: 'Email',
			},
			{
				type: 'textarea',
				rows: 3,
				class: 'col-12',
				model: 'remarks',
				validation: 'required|min:10|max:2000',
				label: 'Remarks',
			},
			{
				type: 'select',
				class: 'col-12',
				model: 'intermediary',
				filterable: true,
				clearable: true,
				options: [],
				validation: 'required',
				label: 'Intermediary',
				sub_label: 'If you wish to lead your friend to an intermediary',
			},
		],
	},
};

module.exports = {
	forms: utils.generateAllFormData(forms),
};
